export function scrollToTop() {
  if (window.scroll) {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  } else {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
}
